// Primary U.S. display time zones (ET/CT/MT/PT) used on the listing booking panel.
export const US_PRIMARY_TIME_ZONES = [
  { shortLabel: 'ET', longLabel: 'Eastern (ET)', timeZone: 'America/New_York' },
  { shortLabel: 'CT', longLabel: 'Central (CT)', timeZone: 'America/Chicago' },
  { shortLabel: 'MT', longLabel: 'Mountain (MT)', timeZone: 'America/Denver' },
  { shortLabel: 'PT', longLabel: 'Pacific (PT)', timeZone: 'America/Los_Angeles' },
];

export const getUsPrimaryTimeZoneLabel = timeZone =>
  US_PRIMARY_TIME_ZONES.find(z => z.timeZone === timeZone)?.shortLabel || null;

const getUsPrimaryTimeZoneFromTimeZoneIana = timeZone => {
  if (!timeZone) return null;
  return US_PRIMARY_TIME_ZONES.some(z => z.timeZone === timeZone) ? timeZone : null;
};

/**
 * Default timezone for showing bookable times to customers.
 * Matches the listing page booking form: browser TZ when it is ET/CT/MT/PT,
 * otherwise Eastern (ET).
 */
export const getDefaultDisplayTimeZone = fallbackTimeZone => {
  if (typeof window === 'undefined') {
    return getUsPrimaryTimeZoneFromTimeZoneIana(fallbackTimeZone) || 'America/New_York';
  }

  const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return getUsPrimaryTimeZoneFromTimeZoneIana(browserTimeZone) || 'America/New_York';
};
